import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button, EmptyState } from '../shared/ui';

/** Last-resort boundary: a failed chunk load (new deploy) or an unexpected render error. */
export function RouteError() {
  const error = useRouteError();
  const { t } = useTranslation();
  const chunk =
    error instanceof Error && /dynamically imported module|Loading chunk/i.test(error.message);
  if (isRouteErrorResponse(error) && error.status === 404) {
    return <EmptyState title={t('notFound.title')} body={t('notFound.body')} />;
  }
  return (
    <div style={{ padding: 'var(--space-6)' }}>
      <EmptyState
        icon="refresh"
        title={chunk ? t('errors.newVersion') : t('errors.crashTitle')}
        body={chunk ? t('errors.newVersionBody') : t('errors.crashBody')}
        action={
          <Button variant="primary" icon="refresh" onClick={() => window.location.reload()}>
            {t('common.reload')}
          </Button>
        }
      />
    </div>
  );
}
